<div class="modal-box process-order-payment-modal" cdkDrag>
    <div class="modal-header process-order-payment-modal__header" cdkDragHandle>
        <div class="process-order-payment-modal__headline">
            <span class="process-order-payment-modal__eyebrow">{{ 'PAYMENT' | translate }}</span>
            <h4 class="modal-title process-order-payment-modal__title">{{ 'CARD_INFO' | translate }}</h4>
        </div>
        <button type="button" class="process-order-payment-modal__close" [attr.aria-label]="'CLOSE' | translate" (click)="activeModal.dismiss('Cross click')">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body process-order-payment-modal__body">
        <div class="process-order-payment-modal__sections">
            <section class="process-order-payment-modal__panel process-order-payment-modal__panel--wide">
                <div class="process-order-payment-modal__panel-header">
                    <span class="process-order-payment-modal__panel-eyebrow">{{ 'CHECKOUT' | translate }}</span>
                    <h5 class="process-order-payment-modal__panel-title">{{ 'REVIEW_CARD_DETAILS_AND_COMPLETE_PAYMENT' | translate }}</h5>
                </div>

                <div class="process-order-payment-modal__checkout-wrap">
                    <app-product-checkout [iAllMyClients]="iAllMyClients"></app-product-checkout>
                </div>
            </section>
        </div>
    </div>

    <div class="modal-footer process-order-payment-modal__footer" cdkDragHandle>
        <div class="process-order-payment-modal__actions">
            <button type="button" class="red-outline-button process-order-payment-modal__button" (click)="activeModal.close('Close click')">{{ 'CLOSE' | translate }}</button>
            <button type="button" class="blue-button process-order-payment-modal__button" (click)="oSaveClick()">{{ 'PAY' | translate }}</button>
        </div>
    </div>
</div>
